import _ from 'lodash';
import type { Study } from './biodirectProgress.types';

/**
 * Tells the study card's progress section whether the study runs through Biodirect. Checks the study's biofluxDirect field for emptiness with lodash and exposes the result as isBiodirectStudy.
 *
 * @param study - Study whose biofluxDirect field is inspected.
 * @returns A flag marking the study as Biodirect.
 */
export const useBiodirectProgress = (study: Study) => {
  const isBiodirectStudy = !_.isEmpty(study.biofluxDirect);

  return { isBiodirectStudy };
};
